import React from 'react';
import styles from './Section.module.scss';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Section = ({ className, children, ...props }) => {
  return (
    <section className={classNames(styles.section, className)} {...props}>
      {children}
    </section>
  );
};

Section.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

Section.defaultProps = {
  className: null,
  children: null,
};

export default Section;
